module.exports = __webpack_public_path__ + "img/judyslogo.ca3551ed.png";